import { render, staticRenderFns } from "./SvgSportCategory.vue?vue&type=template&id=2b7f8b5e&scoped=true"
import script from "./SvgSportCategory.vue?vue&type=script&lang=js"
export * from "./SvgSportCategory.vue?vue&type=script&lang=js"
import style0 from "./SvgSportCategory.vue?vue&type=style&index=0&id=2b7f8b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f8b5e",
  null
  
)

export default component.exports